import $ from 'jquery';

/**
 * Every DataTable's <table> goes in its own sideways-scrolling box (.dt-scroll-x,
 * AdminTheme.css), so a wide table (Order Management's 14 columns) scrolls under the
 * search box while "Showing…" and Previous / Next stay put below it. Layout only:
 * DataTables keeps working on the same table, and destroy() puts it back as before.
 */
$(document).on('init.dt', (e, settings) => {
    const table = $(settings.nTable);
    if (!table.parent().hasClass('dt-scroll-x')) {
        table.wrap('<div class="dt-scroll-x"></div>');
    }
});
